'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // For web-components internal use. For use as an actual web-component, see
// winresReservationPayButton which wraps this.
//
// This is used in
//   * shopping cart tabs
//   * winresReservationPayButton (which only wraps this in
//                                 winres-reservation-component)
//   * winresReservationPayment if the radiobutton method for selecting payment
//     is used.


var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PayButtonController = function () {
    function PayButtonController($rootScope, $scope, modalService, $filter) {
        _classCallCheck(this, PayButtonController);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$filter = $filter;
        this.modalService = modalService;
        this.$scope.taxAmount = null;
        this.$scope.total = null;
    }

    _createClass(PayButtonController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getConfirmBookingResult()
            // getPaymentMethods()
            // getErrors()
            // getContext().Products
            // getContext().AcceptTerms
            // getContext().SelectedDeparture
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().NumInfants
            // getContext().HiddenPrice

            // Set:
            // setCurrentPhase()

            // Other:
            // confirmBookingByInvoice()
            // toPayment()

            if (!this.winresReservationContext) {
                if (window.definiteWinresReservationContext) {
                    console.log('[pay-button]', 'Context is not available. Falling back to global.');
                    this.winresReservationContext = window.definiteWinresReservationContext;
                } else {
                    throw new Error('A context is required.');
                }
            }

            this.data = this.winresReservationContext.getContext();

            // Cannot assign 'pay' to an '@' binding, thus copy to actualTargetPhase
            this.actualTargetPhase = this.targetPhase || 'pay';

            // Selected payment method changed
            this.$scope.$watch(function () {
                return _this.payDirectly;
            }, function () {
                _this.updatePaymentMethod();
            });

            // Payment methods were loaded from backend, potentially with changed
            // payment fees.
            this.$scope.$on('paymentMethodsUpdated', function () {
                return _this.updatePaymentMethod();
            });

            this.openShoppingBasketIfReturningFromPayment();

            // this.$scope.$watch(() => this.winresReservationContext.getCurrentPhase(),
            //       phase => {
            //         console.log("[payButton] phase is: ", phase);
            //       if (phase === 'thankyou') {
            //           console.log("[payButton] phase is 'thankyou' ");
            //         if(this.paymentOkCall) {
            //           this.paymentOkCall({'window': window});
            //         }
            //     }
            //   });


            // this.$scope.$watch(
            //   () => this.winresReservationContext.getConfirmBookingResult(),
            //   result => {
            //     this.bookingResult = result;
            //     console.log("[paybutton] bookingResult: ", this.bookingResult);
            //   }
            // );

            this.confirmBookingResult = this.winresReservationContext.getConfirmBookingResult();
            this.$scope.$on('confirmBooking', function () {
                console.log("[paybutton]  'confirmBooking' received! ");
                if (_this.paymentOkCall) {
                    _this.paymentOkCall({ 'window': window });
                }
            });

            this.$scope.$watch(function () {
                return _this.data.Products;
            }, function () {
                return _this.refreshCartTotals();
            }, true);

            this.$scope.$watchCollection(function () {
                return _this.data.DiscountProducts;
            }, function () {
                return _this.refreshCartTotals();
            }, true);

            this.$scope.$watchCollection(function () {
                return _this.data.GiftCards;
            }, function () {
                return _this.refreshCartTotals();
            }, true);

            // Go to payment or show errors.
            this.$scope.$on('clickPayButton', function () {
                return _this.click();
            });
        }
    }, {
        key: 'updatePaymentMethod',
        value: function updatePaymentMethod() {
            var _this2 = this;

            if (!this.payDirectly || this.payDirectly == 'false') {
                // If the payment button just opens a detailed payment page, payment
                // method cannot be known yet. Thus, payment fee is also unknown.
                this.PaymentFee = 0;
                this.PaymentFeeTaxAmount = 0;
            } else {
                this.PaymentFee = null;
                this.PaymentFeeTaxAmount = null;
                this.winresReservationContext.getPaymentMethods().then(function (methods) {
                    var method = _.find(methods, function (method) {
                        return method.InternalName == _this2.payDirectly;
                    });
                    if (!method) {
                        return;
                    }
                    _this2.PaymentFee = method.Fee;
                    // paymentFee = (1 + taxp) * paymentFeeWithoutTax
                    var paymentFeeWithoutTax = method.Fee / (1 + method.FeeTaxPercent * 0.01);
                    _this2.PaymentFeeTaxAmount = method.Fee - paymentFeeWithoutTax;
                });
            }
        }
    }, {
        key: 'click',
        value: function click() {
            this.$rootScope.$broadcast('updatePaymentMethods');

            switch (this.actualTargetPhase) {
                case 'popup':
                    if (this.reservationHasErrors()) {
                        this.winresReservationContext.showErrors();
                    } else {
                        this.$rootScope.$broadcast('winresOpenPopup', true);
                    }
                    break;
                case 'call':
                    if (this.reservationHasErrors()) {
                        this.winresReservationContext.showErrors();
                    } else {
                        this.call({ 'window': window });

                        // Hide continue button for shopping cart.
                        this.winresReservationContext.setCurrentPhase('');
                    }
                    break;
                case 'pay':
                    this.payClick();
                    break;
                default:
                    // NOTE: No error checking here. It is assumed that the target
                    // phase has an additional payment button which does the error
                    // checking.
                    this.goToTargetPhase();
            }
            //this.$rootScope.$broadcast("pay-button-click");

            // Google analytics.
            // Open modal.
            if (!this.reservationHasErrors()) {
                this.winresReservationContext.analyticsEvent("trackCheckout", 2);
                if (this.data.AcceptTerms) // If accept terms is set by default.
                    this.winresReservationContext.analyticsEvent("trackCheckout", 3);

                this.winresReservationContext.dataLayerEvent('onOpenCart', this.data.Products);
            }
        }

        // Special case for when target-phase is "pay"

    }, {
        key: 'payClick',
        value: function payClick() {
            if (this.reservationHasErrors()) {
                this.winresReservationContext.showErrors();
            } else if (!this.data.AcceptTerms && this.termsSwitch === 'true') {
                alert(this.$filter('i18next')('reservation_customer.error_terms'));
            } else if (this.payDirectly && this.payDirectly != 'false') {
                this.goDirectlyToPayment();
            } else {
                this.goToTargetPhase();
            }
        }
    }, {
        key: 'goToTargetPhase',
        value: function goToTargetPhase() {
            this.winresReservationContext.setCurrentPhase(this.actualTargetPhase, this.scroll);
        }
    }, {
        key: 'goDirectlyToPayment',
        value: function goDirectlyToPayment() {
            var _this3 = this;

            // Value of payDirectly is the internal name of the payment
            // method
            if (this.bookByInvoice == 'true') {
                if (this.yesNo != 'false') {
                    this.modalService.confirm('common.are_you_sure_confirm', 'common.are_you_sure_confirm_text').then(function (result) {
                        if (result) {
                            _this3.winresReservationContext.confirmBookingByInvoice();
                        }
                    });
                } else {
                    this.modalService.yesNo('common.are_you_sure_confirm', 'common.are_you_sure_confirm_text').then(function (result) {
                        if (result) {
                            _this3.winresReservationContext.confirmBookingByInvoice();
                        }
                    });
                }
            } else {
                this.winresReservationContext.toPayment(this.payDirectly);
            }
        }
    }, {
        key: 'isCapacityBoolean',
        value: function isCapacityBoolean() {
            if (this.hideWhenNoCapacity === 'true' && this.data.SelectedDeparture != null) {
                return this.getTotalPeople() <= this.data.SelectedDeparture.CapacityAvailable;
            } else {
                return true;
            }
        }
    }, {
        key: 'getTotalPeople',
        value: function getTotalPeople() {
            return this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
        }
    }, {
        key: 'reservationHasErrors',
        value: function reservationHasErrors() {
            //console.log(this.noErrors);
            if (this.noErrors == 'true') {
                return false;
            } else {
                return this.winresReservationContext.hasErrors() === true;
            }
        }

        // Gets total tax, including tax on payment fee (credit card fee)

    }, {
        key: 'getTax',
        value: function getTax() {
            if (!this.data) {
                return null;
            }
            var tax = 0;
            _.each(this.data.Products, function (productLine) {
                // Assuming we don't have to calculate tax amount if the amount of products is zero
                if (productLine.Amount > 0) {
                    //console.log("paybutton get tax handling product '" + productLine.Product.DestinationInfo.ProductName + "', productline :", productLine);
                    //console.log("this.data.Products: ", this.data.Products);
                    var taxFraction = (productLine.TaxPercent || 0) / 100 || 0;
                    // toString() is inside parseFloat to ensure we can use replace() on the value  without error
                    var productPrice = productLine.Amount * parseFloat(productLine.Product.Price.toString().replace(',', '.'));
                    // Solve for tax
                    // productPrice = (1 + taxFraction) * (productPrice - tax)
                    // productPrice / (1 + taxFraction) = productPrice - tax
                    // tax = productPrice - productPrice / (1 + taxFraction)
                    tax += productPrice - productPrice / (1 + taxFraction);
                }
            });
            return tax + (this.PaymentFeeTaxAmount || 0);
        }

        // Gets total payment sum, including payment fee (credit card fee)

    }, {
        key: 'getTotal',
        value: function getTotal(withoutDiscount, withoutGiftCards) {

            // Return null when paymentfee is updating as not to display too low
            // price.
            if (!this.data /* || this.PaymentFee === null*/) {
                    return null;
                }

            //console.log("getTotal(): this.$rootScope.reservationFee: ", this.$rootScope.reservationFee);

            var products = this.data.Products;
            var giftCardTotal = 0;

            if (!withoutDiscount) {
                // Add discount product prices
                if (this.data.DiscountProducts) {
                    products = _.concat(products, this.data.DiscountProducts);
                }
            }

            if (!withoutGiftCards) {
                if (this.data.GiftCards) {
                    giftCardTotal = _.sumBy(this.data.GiftCards, function (gc) {
                        return gc.Amount;
                    });
                }
            }

            return _.sumBy(products, function (productLine) {
                return productLine.TotalPrice || 0;
            }) + (this.data.HiddenPrice || 0) - giftCardTotal + this.PaymentFee;
            // ReservationFee is added in the template, so the total can update once the reservationFee call has resolved
        }

        // This function check for "bookingSessionId and if found opens modal
        // This is because the call checking for if payment was ok and then opening the modal can be slow
        // See paybutton.js line 55: this.$scope.$on('confirmBooking', () => {

    }, {
        key: 'openShoppingBasketIfReturningFromPayment',
        value: function openShoppingBasketIfReturningFromPayment() {
            if (window.location.href.indexOf("bookingSessionId") > -1) {
                console.log("[paybutton.js] The URL contains 'bookingSessionId', assuming that we returned from payment and opening shopping basket modal now...");
                if (this.paymentOkCall) {
                    this.paymentOkCall({ 'window': window });
                }
            }
        }
    }, {
        key: 'refreshCartTotals',
        value: function refreshCartTotals() {
            //console.log("Refreshing cart totals..");
            this.$scope.taxAmount = this.getTax();
            this.$scope.total = this.getTotal(false, false);
            this.$scope.totalBeforeDiscount = this.getTotal(true, true);
            this.$scope.totalBeforeGiftCards = this.getTotal(false, true);
            this.$scope.totalDiscount = this.$scope.totalBeforeGiftCards - this.$scope.totalBeforeDiscount;
            this.$scope.totalGiftCards = this.$scope.total - this.$scope.totalBeforeGiftCards;
            this.data.totalPrice = (this.$rootScope.reservationFee || 0) + this.$scope.total;
        }
    }]);

    return PayButtonController;
}();

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'pay-button';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('pay-button', require('./payButton.html'));
}]);

PayButtonController.$inject = ['$rootScope', '$scope', 'modalService', '$filter'];

_module3.default.component('payButton', {
    templateUrl: getTemplate,
    controller: PayButtonController,
    require: {
        winresReservationContext: '?^^winresReservationContext'
    },
    // NOTE: When adding bindings here, it should (probably) by added to
    // winresPayButton as well to make it available for non-internal use.
    // NOTE: This same documentation exists in winresReservationayButton.js.
    // Keep the comments in sync.
    bindings: {
        // Title when moving to payment. E.g. "To payment". Not required.
        // By default, reservation_customer.go_pay is used.
        title: '@',
        // "true" or not set. Allows booking by invoice when booking total is NOT set to zero ( 0 ).
        bookByInvoice: '@',
        // "false" (defaul) or payment method code "NTS"/"c"/"VMLK"/...
        // In this case, targetPhase must be "pay" or empty.
        payDirectly: '@',
        // Go to this phase when clicked.
        // The following values have aspecial meaning:
        //  "pay" (default). Has special handling for direct payment etc.
        //  "popup". Opends winres-reservation-popup
        //  "call". Calls window.showShoppingBasket() function.
        targetPhase: '@',
        // Scope has window. thus, window.$('.shopping-cart').show() works in on-add.
        call: '&',
        // Run this on paymentOK (phase=thankyou). Scope has window. thus, window.$('.shopping-cart').show() works in the parameter.
        paymentOkCall: '&',
        //Default true.
        showTax: '@',
        // if you don't want errors displayed, make sure to display them in some other place
        noErrors: '@',

        //if true uses modalservice.confirm instead of modalservice.yesNo
        yesNo: '@',

        // default: false;
        hideWhenNoCapacity: '@',

        // this is just routed here from winresReservationPayButton.
        termsSwitch: '@',

        // scroll on phase change
        scroll: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/payButton/payButton.js
// module id = 379
// module chunks = 2